"use client";
import { Star } from "lucide-react";
import dynamic from "next/dynamic";
const Masonry = dynamic(
	() => import("react-layout-masonry").then((m) => m.default),
	{ ssr: false },
);

export function Testimonials() {
	const testimonials = [
		{
			name: "Blandine R.",
			role: "Coach, consultante et formatrice",
			content: `Avant d’avoir accès au site Altura, j’avais déjà un site que je gérais seule depuis plusieurs années. Mais je rencontrais de plus en plus de difficultés techniques et de performance, au point de ne plus vraiment pouvoir le remettre à jour. J’avais donc besoin de repartir sur une nouvelle base : un nouveau site, un nouveau nom de domaine, une structure plus claire. Le site clé en main a été une vraie opportunité pour moi. J’ai pu obtenir rapidement un site prêt à l’emploi, avec une structure adaptée à mon activité. J’ai simplement ajouté mes textes et mes images, ce qui m’a permis de gagner énormément de temps. Les vidéos tuto que tu proposes sont très bien faites : courtes, claires et pertinentes. Elles vont droit au but, sans superflu, et facilitent vraiment la prise en main du site, même pour les personnes qui ne sont pas à l’aise avec la technique. Aujourd’hui, mon site est en ligne et je suis très satisfaite. D’ailleurs, après quelques vérifications, Google m’indique déjà de bons résultats en performance et en SEO (j’y ai aussi consacré du temps, évidemment). En résumé, je recommande vivement cette formule : simple, rapide et efficace !`,
			rating: 5,
		},
		{
			name: "Amélie B.",
			role: "Formatrice TRE",
			content: `Super facile, tu t'es chargée de tout, j'ai pas eu a "bouscluer" mon quotidien pour que tu le gères. Les vidéos tutos, j'ai aimé le fait que tu ailles à l'essentiel, c'est clair et simple! j'ai connu d'autres tutoriels trop longs et compliqués pour rien; donc je pense que tout est ok`,
			rating: 5,
		},
		{
			name: "Alain G.",
			role: "Captation d'images par drônes",
			content: `ALTURA par Audrey HOSSEPIAN est une bonne solution pour qui veut créer son propre site internet avec un dispositif très pertinent . J'ai pu développer sur cette base, prête à être modifiée, mes idées et mes envies pour présenter mon activité. La création d'un site internet est un "métier", on ne s'improvise pas web developer ! Audrey est là pour vous supporter avec des prestations à la carte. Très professionnelle et disponible, je vous recommande à elle. Merci pour tout.`,
			rating: 5,
		},
		{
			name: "Jordan T.",
			role: "Coach sportif",
			content: `j'ai regardé le modèle et ça m'a plu, simple et efficace à mon sens; ça tombait au moment où je voulais changer`,
			rating: 5,
		},
		{
			name: "Laurence M.",
			role: "Ghost writer",
			content: `ALTURA m’a permis d’avoir un site pro en quelques jours, sans galère technique. Simple, rapide, efficace`,
			rating: 5,
		},
		{
			name: "Laurie G.",
			role: "Psychologue",
			content: `Je repoussais la création de mon site depuis des mois, faute de temps et de budget. Avec ALTURA, tout s’est fait naturellement : process clair, design conforme à mes couleurs et livraison express. Aujourd’hui, je recommande cette solution à tous les indépendants qui veulent un site pro sans prise de tête et qui comme moi ne peuvent pas y mettre beaucoup d'argent 😅.`,
			rating: 5,
		},
	];

	return (
		<section className="py-20 bg-white" id="testimonials">
			<div className="container-large sm:px-6 lg:px-8">
				<h2 className="font-['DM_Serif_Text',serif] text-5xl text-center text-gray-900 mb-4">
					Ce qu'en disent mes clients
				</h2>
				<p className="text-xl text-center text-gray-600 mb-16">
					Des indépendants comme vous qui ont franchi le pas
				</p>

				<Masonry columns={{ 640: 1, 768: 2, 1024: 3 }} gap={30}>
					{testimonials.map((testimonial, index) => (
						<div
							key={index}
							className="bg-gradient-to-b from-gray-50 to-white p-6 rounded-2xl border border-gray-200 hover:shadow-lg transition-all"
						>
							<div className="flex gap-1 mb-4">
								{[...Array(testimonial.rating)].map((_, i) => (
									<Star
										key={i}
										className="w-5 h-5 fill-amber-400 text-amber-400"
									/>
								))}
							</div>
							<p className="text-gray-700 mb-4 leading-relaxed italic">
								“{testimonial.content}”
							</p>
							<div>
								<p className="text-gray-900">
									{testimonial.name}
								</p>
								<p className="text-sm text-gray-600">
									{testimonial.role}
								</p>
							</div>
						</div>
					))}
				</Masonry>
			</div>
		</section>
	);
}
